import React, { CSSProperties } from 'react';
import swal from 'sweetalert2';
import { httpClient } from '@cocoplatform/coco-rtc-client';
import { reportServerError } from 'utils/report-error';
import { inPast } from 'utils/date';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import Menu from '@mui/material/Menu';
import ShareIcon from '!!react-svg-loader!./icons/icon--space-share.svg';
import MenuItem from '@mui/material/MenuItem';
import isString from 'lodash/isString';
import IconImg from 'components/icon-img/IconImg';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BorderColorIcon from '!!react-svg-loader!./icons/icon--space-edit.svg';
import ArchiveOutlinedIcon from '!!react-svg-loader!./icons/icon--archive.svg';
import ContentCopyOutlinedIcon from '!!react-svg-loader!./icons/icon--duplicate.svg';
import DeleteForeverOutlinedIcon from '!!react-svg-loader!./icons/icon--trash.svg';
import ErrorOutlineOutlinedIcon from '!!react-svg-loader!./icons/icon--report.svg';
import { useCommunityDetails } from 'atoms/community-details';
import { spaceEndedEvt, useSpaceSummary } from 'atoms/spaces';
import { useUserProfile } from 'atoms/user-profile';
import { isHost, isManager } from 'constants/community-roles';
import { useHistory } from 'react-router-dom';
import TimeIcon from '!!react-svg-loader!./icons/icon--time.svg';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { LockOutlined } from '@mui/icons-material';

interface ActionMenuItem {
  label: string;
  icon: any;
  action: () => void;
}

export default function SpaceActionsMenu(p: {
  spaceId: string;
  className?: string;
  style?: CSSProperties;
}) {
  const { _ } = useLingui();
  const { space, conclude, restore, refetch } = useSpaceSummary({
    spaceId: p.spaceId,
  });
  const { community, loadCommunityDetails } = useCommunityDetails({
    communityId: space?.communityId ?? undefined,
    autoLoad: false,
  });
  const { userProfile } = useUserProfile();
  const communityRoles = community?.roles ?? [];
  const isCommunityHost = isHost(communityRoles);
  const isCommunityManager = isManager(communityRoles);
  const selfHostIdx =
    userProfile &&
    space?.hosts?.findIndex((user) => {
      return user.id === userProfile?.id;
    });
  const isSelfHosted = selfHostIdx != null && selfHostIdx >= 0;
  const history = useHistory();

  if (!space) return null;

  return (
    <PopupState variant='popover' popupId='space-actions-menu'>
      {(popupState) => {
        const spaceActionsMenu: ActionMenuItem[] = [];
        {
          /*{
            label: 'Share',
            icon: ShareIcon,
            action: () => {
              popupState.close();
              try {
                navigator.clipboard.writeText(
                  `${location.origin}/app/dashboard/${space.communityId}/spaces/${space.id}`,
                );
                alert('Copied url to clipboard');
              } catch (error) {
                reportServerError({
                  error,
                  title: 'Failed to copy url to clipboard',
                });
              }
            },
          }, */
        }
        if (
          (isCommunityHost || isCommunityManager || isSelfHosted) &&
          space?.communityId
        ) {
          spaceActionsMenu.push({
            label: _(msg`Edit`),
            icon: BorderColorIcon,
            action: () => {
              popupState.close();
              history.push(
                `/app/dashboard/${space.communityId}/spaces/${space.id}/edit`,
              );
            },
          });
        }
        spaceActionsMenu.push({
          label: _(msg`Remix`),
          icon: ContentCopyOutlinedIcon,
          action: async () => {
            popupState.close();
            const action = 'remix';
            const {
              data: { spaceId },
            } = await httpClient.post(
              `/community/${space.communityId}/spaces/${space.spaceId}/clone/${action}`,
            );
            history.push(
              `/app/dashboard/${space.communityId}/spaces/${spaceId}/edit?post=${action}`,
            );
          },
        });
        {
          /* Disable ending space option for now */
        }
        {
          /* 
        if (isSelfHosted && !space.endedAt) {
          spaceActionsMenu.push({
            label: 'End',
            icon: TimeIcon,
            action: async () => {
              popupState.close();
              const { isConfirmed } = await swal.fire({
                title: 'End this space ?',
                text: `This space will be ended. Members will be able to explore projects but not participate. Existing co-creators will also not be able to make any further changes.`,
                showCancelButton: true,
              });
              if (!isConfirmed) return;
              await conclude({ end: true });
              spaceEndedEvt.post({ space });
            },
          });
        } 
        */
        }
        {
          /* Disable archive space option for now */
        }
        /* if ((isSelfHosted || isCommunityManager) && space.communityId) {
          if (space.archivedAt) {
            spaceActionsMenu.push({
              label: _(msg`Restore`),
              icon: ArchiveOutlinedIcon,
              action: async () => {
                popupState.close();
                const { isConfirmed } = await swal.fire({
                  title: _(
                    msg`Are you sure that you want to restore this space?`,
                  ),
                  showCancelButton: true,
                });
                if (!isConfirmed) return;
                restore();
              },
            });
          } else {
            spaceActionsMenu.push({
              label: _(msg`Archive`),
              icon: ArchiveOutlinedIcon,
              action: async () => {
                popupState.close();
                const { isConfirmed } = await swal.fire({
                  title: _(msg`Are you sure you want to archive this space?`),
                  showCancelButton: true,
                  footer: `<div>${_(
                    msg`You will be able to restore it later.`,
                  )}</div>`,
                });
                if (!isConfirmed) return;
                conclude({ archive: true });
              },
            });
          }
        }*/

        if (space.sharingEnabled && isCommunityManager && space.communityId) {
          spaceActionsMenu.push({
            label: _(msg`Make space private`),
            icon: LockOutlined,
            action: async () => {
              popupState.close();

              const formData = new FormData();
              formData.append(
                'input',
                JSON.stringify({ sharingEnabled: false, title: space.title }),
              );
              await httpClient.put(`/spaces/${space.id}`, formData);
              refetch();
            },
          });
          spaceActionsMenu.push({
            label: _(msg`Copy sharing link`),
            icon: ContentCopyOutlinedIcon,
            action: async () => {
              popupState.close();
              navigator.clipboard.writeText(
                `${location.origin}/@${community?.handle}/space/${space.id}`,
              );
            },
          });
        }

        if (isCommunityManager && space.communityId) {
          spaceActionsMenu.push({
            label: _(msg`Delete`),
            icon: DeleteForeverOutlinedIcon,
            action: async () => {
              popupState.close();
              const { isConfirmed } = await swal.fire({
                title: _(msg`Are you sure you want to delete this space?`),
                showCancelButton: true,
                // eslint-disable-next-line lingui/no-unlocalized-strings
                footer: `<div>
                  <strong>${_(
                  msg`This operation can not be undone.`,
                )}</strong> ${_(
                  msg`Unless you are absolutely sure, we recommend archiving this space.`,
                )}</div>
                </div>`,
              });
              if (!isConfirmed) return;
              conclude({ delete: true });
            },
          });
        }

        if (!isSelfHosted) {
          spaceActionsMenu.push({
            label: _(msg`Report`),
            icon: ErrorOutlineOutlinedIcon,
            action: async () => {
              popupState.close();
              const { isConfirmed } = await swal.fire({
                title: _(msg`Are you sure that you want to report this space?`),
                showCancelButton: true,
                footer: `<div>${_(
                  msg`Community admin will be notified and will take appropriate action.`,
                )}</div>`,
              });
              if (!isConfirmed) return;
              await httpClient.post(`/community/${space.communityId}/report`);
            },
          });
        }

        const triggerProps = bindTrigger(popupState);
        return (
          <>
            <span
              {...triggerProps}
              onMouseEnter={(e) => {
                if (!community) loadCommunityDetails();
              }}
              className={p.className}
              style={{ ...p.style, cursor: 'pointer', padding: '5px' }}
            >
              <MoreHorizIcon />
            </span>
            <Menu {...bindMenu(popupState)}>
              {spaceActionsMenu.map(({ icon: Icon, label, action }) => {
                return (
                  <MenuItem key={label} onClick={action}>
                    <ListItemIcon>
                      {isString(Icon) ? (
                        <IconImg src={Icon} />
                      ) : (
                        <Icon style={{ width: '1rem' }} />
                      )}
                    </ListItemIcon>
                    <ListItemText style={{ marginLeft: '-5px' }}>
                      {label}
                    </ListItemText>
                  </MenuItem>
                );
              })}
            </Menu>
          </>
        );
      }}
    </PopupState>
  );
}
